webpackJsonp([106182774615790],{

/***/ 660:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/AuthorBioPageHero60@2x.e79d21b7.jpg";

/***/ }),

/***/ 662:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/SarahBook2.1f589838.jpg";

/***/ }),

/***/ 261:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Glamor) {'use strict';
	
	exports.__esModule = true;
	
	var _g$div, _g$div2, _g$img;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _glamorous = __webpack_require__(13);
	
	var _glamorous2 = _interopRequireDefault(_glamorous);
	
	var _glamor = __webpack_require__(47);
	
	var _reactHelmet = __webpack_require__(38);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _layoutUnits = __webpack_require__(21);
	
	var _banner = __webpack_require__(26);
	
	var _banner2 = _interopRequireDefault(_banner);
	
	var _responsiveMargin = __webpack_require__(27);
	
	var _responsiveMargin2 = _interopRequireDefault(_responsiveMargin);
	
	var _sitenav = __webpack_require__(28);
	
	var _sitenav2 = _interopRequireDefault(_sitenav);
	
	var _AuthorBioPageHero602x = __webpack_require__(660);
	
	var _AuthorBioPageHero602x2 = _interopRequireDefault(_AuthorBioPageHero602x);
	
	var _SarahBook = __webpack_require__(662);
	
	var _SarahBook2 = _interopRequireDefault(_SarahBook);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var maxFloatLayout = '560px';
	
	var ContentLayout = _glamorous2.default.div((_g$div = {
	  display: 'flex'
	}, _g$div['@media (max-width: ' + maxFloatLayout + ')'] = {
	  display: 'block'
	}, _g$div));
	
	var ImageWrapper = _glamorous2.default.div((_g$div2 = {
	  flex: '2',
	  maxWidth: '288px',
	  margin: _layoutUnits.normalMargin + ' 0 0 ' + _layoutUnits.normalMargin
	}, _g$div2['@media (min-width: ' + _layoutUnits.largeBreakpoint + ')'] = {
	  margin: _layoutUnits.largeMargin + ' 0 0 ' + _layoutUnits.largeMargin
	}, _g$div2['@media (max-width: ' + maxFloatLayout + ')'] = {
	  float: 'right',
	  margin: '0 16px'
	}, _g$div2));
	
	var SarahImage = _glamorous2.default.img((_g$img = {
	  minWidth: '160px',
	  filter: 'drop-shadow(0 3px 4px rgba(0, 0, 0, 0.4))',
	  transform: 'rotate(-3deg)'
	}, _g$img['@media (max-width: ' + maxFloatLayout + ')'] = {
	  minWidth: '120px',
	  width: '34vw'
	}, _g$img));
	
	var _ref = { flex: '3' };
	
	exports.default = function () {
	  return Glamor.createElement(
	    'div',
	    null,
	    Glamor.createElement(_reactHelmet2.default, { title: 'Author Bio | Sarah Coleman' }),
	    Glamor.createElement(_banner2.default, { imageUrl: _AuthorBioPageHero602x2.default }),
	    Glamor.createElement(_sitenav2.default, null),
	    Glamor.createElement(
	      ContentLayout,
	      null,
	      Glamor.createElement(
	        ImageWrapper,
	        null,
	        Glamor.createElement(SarahImage, { src: _SarahBook2.default })
	      ),
	      Glamor.createElement(
	        _responsiveMargin2.default,
	        { css: _ref },
	        Glamor.createElement(
	          'h2',
	          null,
	          'Author Bio'
	        ),
	        Glamor.createElement(
	          'p',
	          null,
	          'Sarah Coleman wrote about photography, visual art and film for publications including ',
	          Glamor.createElement(
	            'i',
	            null,
	            'ARTnews'
	          ),
	          ', ',
	          Glamor.createElement(
	            'i',
	            null,
	            'Salon'
	          ),
	          ', ',
	          Glamor.createElement(
	            'i',
	            null,
	            'Communication Arts'
	          ),
	          ', ',
	          Glamor.createElement(
	            'i',
	            null,
	            'Photo District News'
	          ),
	          ' and ',
	          Glamor.createElement(
	            'i',
	            null,
	            'View Camera'
	          ),
	          '. She received a Masters of Fine Arts in creative writing from Columbia University and was a resident artist at Yaddo, Ragdale, the Vermont Studio Center and the Virginia Center for Creative Arts. She blogged about photography and literature at ',
	          Glamor.createElement(
	            'a',
	            { href: 'http://theliteratelens.com' },
	            'theliteratelens.com'
	          ),
	          ', and lived in Manhattan and Woodstock, NY with her husband and two children. Sarah died from lung cancer, shortly after completing The Realist, in December 2017.'
	        )
	      )
	    )
	  );
	};
	
	module.exports = exports['default'];
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(9)))

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-author-bio-js-292b7d78be9516fceeee.js